import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

export default function* () {
	yield takeLatest(ACTION.FETCH_LIST_WAREHOUSE_STAFF.REQUEST, saga.fetchListWarehouseStaff);
}
